import React, {useState, Fragment} from 'react';
import { nuevoOActualizarRegistroPersonalizado, obtenerRegistrosPorURL, setearDatosAlStore } from 'store/actions/customAction';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import DatosDeEmpresa from 'components/nuevoTarifario/DatosDeEmpresa';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import {useDispatch} from 'react-redux';
import NuevoMedioEscrito from './NuevoMedioEscrito';
import { nombreDeAcciones } from 'constantes';
import { alertaPersonalizadaSwal } from 'servicios/AlertasPersonalizados';
import DetalleDelTarifario from 'components/nuevoTarifario/detalleDelTarifario';
import ModalDeConfirmacion from 'components/Modales/ModalDeConfirmacion';

const Escritos = () => {
    const dispatch = useDispatch();
    const [tarifarioDeMediosEscritos] = useState('tarifarioDeMediosEscritos');
    const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', mostrarRespuesta: false, });
    const[cargandoSolicitud, setCargandoSolicitud] = useState(false);
    const [abrirNuevoMedioEscrito, setAbrirNuevoMedioEscrito] = useState(false);
    const [steps] = useState( [{id: 0,  label: 'Datos del medio escrito'}, {id: 1, label: "Tarifario y Disponibilidad"}, {id: 2, label: "Cobertura"}, {id: 3, label: "Datos Demográficos"}]);
    const [datosDeEmpresa, setDatosDeEmpresa] = useState({});
    const [recargarLaTabla, setRecargarLaTabla] = useState(false),
    [datosGeneralesDelTarifario, setDatosGeneralesDelTarifario] = useState({}),
    [abrirDetalleTarifario, setAbrirDetalleTarifario] = useState(false),
    [alertaDeConfirmacion, setAlertaDeConfirmacion] = useState(false);

    const [header] = useState([
        { title: 'Nombre del medio', field: 'medioDeComunicacion.nombre'},
        { title: 'Tipo de medio', field: 'tipoDeMedioEscrito.descripcion'},
        { title: 'Acciones', field: 'accion',
        render: rowData=><div style={{minWidth: '100px'}}>
            {
                (<div>

                    <TooltipPersonalizado title="Visualizar detalle del medio" handleFunction={() => mostrarDetalleDelMedio(rowData)} icon="visibility" fontSize={30} />
                    <TooltipPersonalizado title="Eliminar medio" handleFunction={() => mostrarAlertaDeConfirmacion(rowData)} icon="delete" fontSize={30} color="red" />
                </div>)
            }
            </div>
        },
    ]);

    const mostrarAlertaDeConfirmacion = async (elemento) => {
        setDatosGeneralesDelTarifario(elemento)
        setAlertaDeConfirmacion(true)
    }

    const mostrarDetalleDelMedio = async (elemento) => {
        setCargandoSolicitud(true);

        let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: tarifarioDeMediosEscritos, saveInStore: false, nombreDelMetodo: "listar/registros", parametro: elemento.medioDeComunicacion?.id}));

        setCargandoSolicitud(false);

        if(respuesta?.error) return alertaPersonalizadaSwal(`${respuesta.error?.message || "No se pudo obtener la información"}`);

        if(respuesta?.data?.length === 0) return alertaPersonalizadaSwal("No existen datos para mostrar");

        setDatosGeneralesDelTarifario(respuesta.data)
        setAbrirDetalleTarifario(true)
    }

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta = false) => setDatosDeRespuesta({tipoDeAlerta,mensajeDeAlerta,mostrarRespuesta,})

    const addRegister= () => {
        if(!datosDeEmpresa?.ejecutivoDeMedios?.cui) return alertaPersonalizadaSwal("Debe completar los datos Contacto de medios para agregar otro escrito", "", "warning")
        setAbrirNuevoMedioEscrito(true);
    }

    const cerrarNuevoMedioEscrito= (recargar = false) => {
        dispatch(setearDatosAlStore({ dispatchAction : nombreDeAcciones.LIMPIAR_TODO_EL_REDUCER}));
        setAbrirNuevoMedioEscrito(false)
        setRecargarLaTabla(recargar)
    };

    const cerrarDetalleDelTarifario = () => setAbrirDetalleTarifario(false)

    const accionDeAlertaDeConfirmacion = async () => {
        setAlertaDeConfirmacion(false);
        setCargandoSolicitud(true);
        changeDataResponse('error', "")

        const data = { controller: tarifarioDeMediosEscritos, action: 'deshabilitar', data: {}, nombreDelMetodo: `deshabilitar/${datosGeneralesDelTarifario?.medioDeComunicacion?.id}` };
        const respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(data));
        setCargandoSolicitud(false);
        if(respuesta?.error) return alertaPersonalizadaSwal(respuesta.error?.message || "", "", '');
        alertaPersonalizadaSwal(respuesta?.data || "Registro eliminado correctamente", "", 'success');
        setRecargarLaTabla(true)
    }

    const cerrarAlertaDeConfirmacion = () => setAlertaDeConfirmacion(false);

    const { tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta} = datosDeRespuesta;

    return (
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={mostrarRespuesta} handClose={handClose}/>

            <DatosDeEmpresa
                header={header}
                tituloGeneral={"FORMULARIO DE REGISTRO ESCRITOS"}
                icon={"escritos"}
                tituloDeTabla={"LISTADO DE MEDIOS ESCRITOS REGISTRADOS"}
                addRegister={addRegister}
                nombreToolTip={"AGREGAR OTRO MEDIO ESCRITO"}
                iconTabla={"escritos"}
                setDatosDeEmpresa={setDatosDeEmpresa}
                controladorTarifario={"tarifarioDeMediosEscritos"}
                recargarLaTabla={recargarLaTabla}
                datosDeEmpresa={datosDeEmpresa}
                setRecargarLaTabla={setRecargarLaTabla}
                tipoMedio="escritos"
            />

            {abrirNuevoMedioEscrito && (
                <NuevoMedioEscrito
                    openFullScreenDialog={abrirNuevoMedioEscrito}
                    handleClose={cerrarNuevoMedioEscrito}
                    title={"Formulario para agregar nuevo medio escrito"}
                    steps={steps}
                    datosDeEmpresa={datosDeEmpresa}
                />
            )}
            {abrirDetalleTarifario && (
                <DetalleDelTarifario
                    openFullScreenDialog={abrirDetalleTarifario}
                    handleClose={cerrarDetalleDelTarifario}
                    title={'Detalle del medio registrado'}
                    datosGeneralesDelTarifario={datosGeneralesDelTarifario}
                    tipoDelMedio={"escritos"}
                    mostrarDetalleDelCanal={mostrarDetalleDelMedio}
                />
            )}
            {alertaDeConfirmacion && (
                <ModalDeConfirmacion
                    title={`¿Está seguro de eliminar el medio ${datosGeneralesDelTarifario?.medioDeComunicacion?.nombre || ""}?`} message={"No podrá revertir esta acción"}
                    open={alertaDeConfirmacion} closeModal={cerrarAlertaDeConfirmacion} titleButton={"Sí, estoy seguro"}
                    actionAdd={accionDeAlertaDeConfirmacion}
                />
            )}
        </Fragment>
    );
}

export default Escritos;